var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "m-grid__item m-grid__item--fluid m-wrapper" },
    [
      _c("div", { staticClass: "m-subheader" }, [
        _c("div", { staticClass: "d-flex align-items-center" }, [
          _c("div", { staticClass: "mr-auto" }, [
            _c(
              "h3",
              {
                staticClass: "m-subheader__title m-subheader__title--separator"
              },
              [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm._f("titleize")("user_administration")) +
                    "\n        "
                )
              ]
            ),
            _vm._v(" "),
            _c("ul", {
              staticClass: "m-subheader__breadcrumbs m-nav m-nav--inline"
            })
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "m-content" },
        [
          _c(
            "div",
            { staticClass: "m-portlet m-portlet--tab" },
            [
              _c("div", { staticClass: "m-portlet__head" }, [
                _c("div", { staticClass: "m-portlet__head-caption" }, [
                  _c("div", { staticClass: "m-portlet__head-title" }, [
                    _vm._m(0),
                    _vm._v(" "),
                    _c("h3", { staticClass: "m-portlet__head-text" }, [
                      _vm._v(_vm._s(_vm._f("capitalize")("permissions")))
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "m-portlet__head-tools" }, [
                  _vm.validPermission("create", "permission")
                    ? _c(
                        "button",
                        {
                          staticClass: "btn btn-success m-btn m-btn--icon",
                          attrs: {
                            id: "btn-newpermission",
                            "data-toggle": "modal",
                            "data-backdrop": "static",
                            "data-keyboard": "false",
                            "data-target": "#permission_modal"
                          },
                          on: {
                            click: function($event) {
                              return _vm.updateModalStatus(true)
                            }
                          }
                        },
                        [
                          _c("span", [
                            _c("i", { staticClass: "fa fa-plus-circle" }),
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm._f("capitalize")("create_permission")
                                )
                              )
                            ])
                          ])
                        ]
                      )
                    : _vm._e()
                ])
              ]),
              _vm._v(" "),
              _c("router-view")
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "s-modal",
            {
              attrs: {
                id: "permission_modal",
                title: _vm._f("capitalize")(
                  _vm._f("translate")(
                    _vm.modal_phrases
                      ? "create_phrases"
                      : !_vm.is_edit
                      ? "create_permission"
                      : "edit_permission"
                  )
                )
              }
            },
            [
              _c("s-base-form", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.modal_phrases,
                    expression: "!modal_phrases"
                  }
                ],
                attrs: {
                  slot: "body",
                  pModel: _vm.model,
                  isProfile: false,
                  isEdit: _vm.is_edit
                },
                slot: "body"
              }),
              _vm._v(" "),
              _c("s-new-phrase", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.modal_phrases,
                    expression: "modal_phrases"
                  }
                ],
                attrs: { slot: "body", openOutside: true },
                slot: "body"
              })
            ],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "m-portlet__head-icon m--hide" }, [
      _c("i", {})
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-57dcc68c", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-57dcc68c","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/src/components/admin/Permissions.vue
// module id = 720
// module chunks = 0 1 70